import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { IWidgets } from "../../../../models/master/widgets";
import { IStudentQuickLinks } from "../../../../models/student/studentCourceDetail";
import { useEffect } from "react";
import { setWidgets } from "../../../../store/slices/master/widgetSlice";
import { connect, useDispatch } from "react-redux";
import { baseURL } from "../../../../constants/commonConstants";
import { getWidgets } from "../../../../action/masters/widgetActionCreator";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const QuickLinks = (props: IStudentQuickLinks) => {
  const { getAllWidgets, widgets, snapShots } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.quickLinks);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllWidgets(pageBlockId.quickLinks, limit.three);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  const handleViewAll = () => {
    navigate(ROUTER_URL.QUICK_LINKS_VIEW_ALL);
  };

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Quick Links</h2>
          <a
            onClick={() => handleViewAll()}
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
          >
            View All
          </a>
        </div>
        <div className="row">
          {widgets
            ?.filter((widget: IWidgets) => widget.displayOrNot)
            .map((widget: IWidgets) => (
              <div className="col-lg-12" key={widget.id}>
                <a href={widget.url} target="_blank" rel="noopener noreferrer">
                  <div className="card reportcard mb-3">
                    <div className="widget-card">
                      <div className="desc">
                        <h3>{widget.name}</h3>
                        <p className="para-hide-1">{widget.description}</p>
                        <a href={widget.url} className="btn-arrow">
                          <img
                            src="/assets/images/icon/arrow-right.svg"
                            alt="Arrow icon"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllWidgets: (pageBlockId: number, noOfItems: number) =>
    getWidgets(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    widgets: state.widget.widgets,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickLinks);
